<div class="modal-header">
    <h5 class="modal-title">Modificar Hora de Bloqueo</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="onCancelar()" aria-label="Cerrar"></button>
</div>

<div class="modal-body">
    <form [formGroup]="form" class="row g-3">

        <div class="col-md-6">
            <label for="horaActual" class="form-label">Hora actual de bloqueo</label>
            <input id="horaActual" type="text" class="form-control" formControlName="horaActual" readonly>
        </div>

        <div class="col-md-6">
            <label for="nuevaHora" class="form-label">Nueva hora de bloqueo</label>
            <select id="nuevaHora" class="form-select" formControlName="nuevaHora">
                <option value="">Seleccione una hora</option>
                <option *ngFor="let hora of horasDisponibles" [value]="hora">{{ hora }}</option>
            </select>
        </div>

        <div class="col-12">
            <label for="motivo" class="form-label">Motivo</label>
            <textarea id="motivo" class="form-control" formControlName="motivo" rows="3"></textarea>
            <div *ngIf="motivo.invalid && motivo.errors.required && (motivo.dirty || motivo.touched)" class="alert alert-danger">
                Requerido
            </div>
        </div>

    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="onGuardar()" [disabled]="form.invalid || guardandoHora">Guardar
        cambios</button>
    <button type="button" class="btn btn-secondary" (click)="onCancelar()">Cancelar</button>
</div>